import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import type { UserModel } from '~/models/user'
import type { RoleId } from '~/types/user/user-roles'

export const useUserStore = defineStore('user', () => {
  const authorizedUser = ref<UserModel | null>(null)

  const setAuthorizedUser = (value: UserModel) => {
    authorizedUser.value = value
  }

  const clearUser = () => {
    authorizedUser.value = null
  }

  // Computed геттеры
  const user = computed(() => authorizedUser.value)

  const isAuthenticated = computed(() => !!authorizedUser.value)

  const userRoles = computed(() => authorizedUser.value?.roles || new Set())

  const hasRole = computed(() => (roleId: string): boolean => {
    return userRoles.value.has(roleId as RoleId)
  })

  const isHaveDigitalProfile = computed(() => authorizedUser.value?.isHaveDigitalProfile || false)

  const isHaveResume = computed(() => authorizedUser.value?.isHaveResume || false)


  const userFullName = computed(() => {
    const user = authorizedUser.value
    if (!user) return ''

    const { lastname = '', firstname = '', middlename = '' } = user
    return [lastname, firstname, middlename].filter(Boolean).join(' ')
  })

  return {
    // State
    authorizedUser,

    // Actions
    setAuthorizedUser,
    clearUser,

    // Computed геттеры
    user,
    isAuthenticated,
    userRoles,
    hasRole,
    userFullName,
    isHaveDigitalProfile,
    isHaveResume,
  }
})
